import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "px-4 space-y-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: "Nama Harga",
        class: "w-10/12"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LpInput, {
            modelValue: _ctx.detailData.configurablePriceName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailData.configurablePriceName = $event)),
            disabled: true
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Deskripsi",
        class: "w-10/12"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LpInput, {
            modelValue: _ctx.detailData.configurablePriceDescription,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailData.configurablePriceDescription = $event)),
            type: "textarea",
            maxLength: 500,
            showMaxLength: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _hoisted_3
  ]))
}